import { render, staticRenderFns } from "./GenerateTopicCodes.vue?vue&type=template&id=9da20278&"
import script from "./GenerateTopicCodes.vue?vue&type=script&lang=js&"
export * from "./GenerateTopicCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports